import * as React from 'react';
import { LigneFrais } from './LigneFrais';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import * as ReqType from '../../../types/ServerRequests';
import { EventService } from '../../../services/EventService';

export interface Props {
    frais: ReqType.Frais[];
}

interface State {
    events: ReqType.Event[];
}
/**
 * Ce composant permet l'affichage de la liste des frais
 */
export class ListFrais extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
            events: [],
        };
        EventService.getInstance().getEvents().then(
            (events: ReqType.Event[]) => {
                this.setState({events: events});
            }
        );
    }

    render() {
        var listItems = undefined;

        listItems = this.props.frais.map(
            (frais: ReqType.Frais) => {
                return (
                    <LigneFrais
                        key={frais.id}
                        frais={frais}
                        event={
                            this.state.events.find(
                                (elem: ReqType.Event) => {
                                    return elem.id === frais.event_id;
                                }
                            )
                        }
                    />
                );
            }
        );

        var total = 0;
        this.props.frais.map(
            (frais: ReqType.Frais) => {
                total += Number.parseFloat(frais.montant);
            }
        );

        return (
            <div className="card card-default">
                <div className="card-header col-12">
                    <h4 className="text-white">
                        <strong>Mes informations financières</strong>
                    </h4>
                </div>

                <div className="card-body">
                    <TableChorinitia
                        header={
                            <thead className="thead-light">
                                <tr>
                                    <th scope="col" />
                                    <th scope="col">Animation</th>
                                    <th scope="col">Date animation</th>
                                    <th scope="col">Libellé</th>
                                    <th scope="col">Montant engagé</th>
                                </tr>
                            </thead>
                        }
                    >
                        <tbody>
                            {listItems}
                            <tr>
                                <th scope="col"> Total </th>
                                <td scope="row"> - </td>
                                <td scope="row"> - </td>
                                <td scope="row"> - </td>
                                <td scope="row">{total}</td>
                            </tr>
                        </tbody>

                    </TableChorinitia>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ProfilePage/internalComponents/ListFrais.tsx